<template>
  <van-row class="px-2 py-3 d-flex align-items-center justify-content-center">
    <van-col
      span="12"
      style="padding: 2.4rem 0;"
      class="px-2 efilm">
      <router-link
        :to="{name: 'film'}"
        class="position-relative">
        <van-col span="8">
          <picture>
            <source
              srcset="@/assets/yxjp.webp"
              type="image/webp"
              class="img-fluid">
            <source
              srcset="@/assets/yxjp.png"
              type="image/png"
              class="img-fluid">
            <img
              src="@/assets/yxjp.png"
              alt="购买电子胶片"
              class="img-fluid">
          </picture>
        </van-col>
        <van-col
          span="16"
          class="pl-1">
          <div class="title">影像胶片</div>
          <div class="text">影像胶片快速取阅</div>
        </van-col>
      </router-link>
      <!-- maskABC 用户指引 -->
      <MaskA
        v-if="first && active === 0"
        @click="setMaskActive"/>
    </van-col>
    <van-col
      span="12"
      class="pl-2 pr-1">
      <van-row class="mb-1 p-1 efilm">
        <router-link
          :to="{name: 'report'}"
          class="position-relative">
          <van-col span="8">
            <picture>
              <source
                srcset="@/assets/yxbg.webp"
                type="image/webp"
                class="img-fluid">
              <source
                srcset="@/assets/yxbg.png"
                type="image/png"
                class="img-fluid">
              <img
                src="@/assets/yxbg.png"
                alt="影像报告"
                class="img-fluid">
            </picture>
          </van-col>
          <van-col
            span="16"
            class="pl-1">
            <div class="title">影像报告</div>
            <div class="text">影像报告快速查</div>
          </van-col>
        </router-link>
        <MaskB
          v-if="first && active === 1"
          @click="setMaskActive"/>
      </van-row>
      <van-row class="p-1 efilm">
        <router-link
          :to="{name: 'doctor'}"
          class="position-relative">
          <van-col span="8">
            <picture>
              <source
                srcset="@/assets/zjkp.webp"
                type="image/webp"
                class="img-fluid">
              <source
                srcset="@/assets/zjkp.png"
                type="image/png"
                class="img-fluid">
              <img
                src="@/assets/zjkp.png"
                alt="专家看片"
                class="img-fluid">
            </picture>
          </van-col>
          <van-col
            span="16"
            class="pl-1">
            <div class="title">专家看片</div>
            <div class="text">名医专家在线诊断</div>
          </van-col>
        </router-link>
        <MaskC
          v-if="first && active === 2"
          @click="setMaskActive"/>
      </van-row>
    </van-col>
    <van-popup
      v-model="first"
      @click-overlay="setMaskActive"></van-popup>
  </van-row>
</template>

<script>
import MaskA from './MaskA.vue';
import MaskB from './MaskB.vue';
import MaskC from './MaskC.vue';

export default {
  name: 'HomeNav',
  components: {
    MaskA,
    MaskB,
    MaskC,
  },
  data() {
    return {
      first: true,
      active: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      const first = localStorage.getItem('first');
      if (first) {
        this.first = false;
      }
    });
  },
  methods: {
    setMaskActive(isEnd) {
      this.active = this.active + 1;
      if (isEnd) {
        this.first = false;
        localStorage.setItem('first', false);
      }
    },
  },
};
</script>

<style scoped>
.mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 999;
  height: 100%;
}

/* 375 = 1080px  2.88 */
.efilm {
  border: 1px solid transparent;
  background-color: rgb(250, 250, 250);
  box-shadow: 2px 2px 1px rgb(239, 239, 239);
  border-radius: 4px;
}

.title {
  font-size: 18px;
  padding: 3px 0 1px 0;
  color: rgb(51, 51, 51);
}
.text {
  font-size: 12px;
  padding: 1px 0 2px 0;
  color: rgb(159, 159, 159);
}
</style>
